export const getLongtermWaitlistEntriesKey = (groupOrView, page) => {
  return ["waitlists", "long_term", "entries", groupOrView, page].filter(
    Boolean
  )
}

export const getLongtermWaitlistSettingsKey = () => {
  return ["waitlists", "long_term", "settings"]
}

export const getLongtermWaitlistGroupSettingsKey = () => {
  return ["waitlists", "long_term", "settings", "groups"]
}
